import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { useTranslation } from '../contexts/LanguageContext';

const TermsOfService = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t('terms.seo.title')}
        description={t('terms.seo.description')}
        keywords={['terms of service', 'terms and conditions', 'user agreement']}
        ogUrl="/terms"
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto bg-opacity-15 bg-sky-800 rounded-xl shadow-md p-8 mt-20"
      >
        <h1 className="text-3xl font-bold text-white mb-6">
          {t('terms.title')}
        </h1>
        <div className="prose text-primary-200 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.agreement.title')}
            </h2>
            <p>
              {t('terms.agreement.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.license.title')}
            </h2>
            <p>
              {t('terms.license.text1')}
            </p>
            <p className="mt-2">{t('terms.license.text2')}</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>{t('terms.license.item1')}</li>
              <li>{t('terms.license.item2')}</li>
              <li>{t('terms.license.item3')}</li>
              <li>{t('terms.license.item4')}</li>
              <li>{t('terms.license.item5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.disclaimer.title')}
            </h2>
            <p>
              {t('terms.disclaimer.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.limitations.title')}
            </h2>
            <p>
              {t('terms.limitations.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.links.title')}
            </h2>
            <p>
              {t('terms.links.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.modifications.title')}
            </h2>
            <p>
              {t('terms.modifications.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('terms.contact.title')}
            </h2>
            <p>
              {t('terms.contact.text')}{' '}
              <a href="mailto:asmaessafi137@gmail.com" className="text-sky-500 hover:text-sky-600">
                asmaessafi137@gmail.com
              </a>
            </p>
          </section>
        </div>
      </motion.div>
    </>
  );
};

export default TermsOfService;